import Field from '../Field.jsx';
import FieldGroup from '../FieldGroup.jsx';

export default function DropsSection({ drops, set }) {
  const moneyBack = drops.moneyBack;
  const setM = (field, value) => set(`drops.moneyBack.${field}`, value);

  return (
    <FieldGroup title="Money Back" caption="One economic pool; campaign names can vary later">
      <Field
        label="Pulsar-funded budget"
        value={moneyBack.pulsarMonthlyBudget}
        step={1000}
        onChange={(v) => setM('pulsarMonthlyBudget', v)}
      />
      <Field
        label="Yield-funded share"
        value={moneyBack.yieldShare}
        pct
        step={0.01}
        onChange={(v) => setM('yieldShare', v)}
      />
      <Field
        label="Yield-funded monthly cap"
        value={moneyBack.yieldMonthlyCap}
        step={1000}
        onChange={(v) => setM('yieldMonthlyCap', v)}
      />
      <Field
        label="Paid-user refund budget"
        value={moneyBack.proPaybackMonthlyBudget}
        step={1000}
        onChange={(v) => setM('proPaybackMonthlyBudget', v)}
      />
      <Field
        label="Eligible paid-user share"
        value={moneyBack.proPaybackEligibleShare}
        pct
        step={0.01}
        onChange={(v) => setM('proPaybackEligibleShare', v)}
      />
      <Field
        label="Refund amount / user"
        value={moneyBack.proPaybackRebate}
        step={1}
        onChange={(v) => setM('proPaybackRebate', v)}
      />
      <Field
        label="Partner-sponsored budget"
        value={moneyBack.partnerSponsoredBudget}
        step={5000}
        onChange={(v) => setM('partnerSponsoredBudget', v)}
      />
      <Field
        label="Pulsar co-funding share"
        value={moneyBack.partnerCostShare}
        pct
        step={0.01}
        onChange={(v) => setM('partnerCostShare', v)}
      />
      <Field
        label="Avg money-back amount"
        value={moneyBack.avgRewardAmount}
        step={5}
        onChange={(v) => setM('avgRewardAmount', v)}
      />
      <Field
        label="App accounts / $10 reward"
        value={moneyBack.appAccountsPer10Reward}
        step={0.1}
        decimals={2}
        onChange={(v) => setM('appAccountsPer10Reward', v)}
      />
      <Field
        label="Full-impact budget"
        value={moneyBack.fullImpactMonthlyBudget}
        step={5000}
        onChange={(v) => setM('fullImpactMonthlyBudget', v)}
      />
      <Field
        label="Card activation lift"
        value={moneyBack.cardActivationLift}
        pct
        step={0.001}
        onChange={(v) => setM('cardActivationLift', v)}
      />
      <Field
        label="Pro conversion lift"
        value={moneyBack.proConversionLift}
        pct
        step={0.001}
        onChange={(v) => setM('proConversionLift', v)}
      />
      <Field
        label="Churn reduction"
        value={moneyBack.churnReduction}
        pct
        step={0.01}
        onChange={(v) => setM('churnReduction', v)}
      />
    </FieldGroup>
  );
}
